import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import FileUploadField from "../../../components/Fields/FileUploadField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import FileCreateResultModel from "../../../models/FileCreateResultModel";
import DataService from "../../../services/data.service";
import { DataResult } from "../../../types/Result";

interface ChangeProfilePictureModel {
    userId: number
    fileName?: string
    fileResult?: FileCreateResultModel
}

interface IProps {
    show: boolean
    onHide: (fileUrl?: string) => void
    userId: number
}

const ChangeProfilePicturePopup: React.FC<IProps> = ({ show, onHide, userId }) => {
    const [file, setFile] = useState<File>();
    const [serverErrors, setServerErrors] = useState<DataResult<ChangeProfilePictureModel>>({ isSuccesful: true, messages: [], data: undefined });

    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ChangeProfilePictureModel>({
        userId: userId,
    });

    function submit() {
        if (formData && file) {
            DataService
                .createFile(file)
                .then(fileResponse => {
                    handleResult(fileResponse);
                    if (fileResponse.isSuccesful === true && fileResponse.data) {
                        formData.fileResult = fileResponse.data;
                        DataService
                            .create<ChangeProfilePictureModel>(`api/v1/Users/changeprofilepicture`, formData)
                            .then(response => {
                                handleResult(response);
                                setServerErrors(response);
                                if (response.isSuccesful === true) {
                                    if (onHide && fileResponse.data)
                                        onHide(fileResponse.data.thumbnailFileUrl);
                                }
                            })
                            .catch(e => handleException(e));
                    }
                    else {
                        handleResult(fileResponse);
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string | File): void {
        if (name === 'fileName' && typeof (value) === 'object') {
            setFile(value);
            formData.fileName = value.name;
        }
        else {
            formData[name] = value;
        }
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'fileName', label: 'File', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Change profile picture'} >
            <Popup.Body>
                <FileUploadField {...getFieldProps('fileName')} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Change' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default ChangeProfilePicturePopup;